export default __webpack_public_path__ + "static/media/f413a57d67b88e82515fae53758cd2d0.png";